import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./AirlinesSelect.module.css";

export default function AirlinesSelect({ options, onChange }) {
  const [selected, setSelected] = useState(options[0].label);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setSelected(newValue);
    if (onChange) {
      onChange(newValue); 
    }
  };

  const match = options.find((option) => option.label === selected);

  return (
    <div className={styles.container}>
      <div className={styles.airlinesSelect}>
        <p className={styles.label}>Select an airline:
        <select
          className={styles.selector}
          value={selected}
          onChange={handleChange}
        >
          {options.map((option) => (
            <option key={option.label} value={option.label}>
              {option.label}
            </option>
          ))}
        </select>
        </p>
      </div>
      <div className={styles.children}>
      {match && match.children}
      </div>
    </div>
  );
}

AirlinesSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      children: PropTypes.node,
    })
  ).isRequired,
  onChange: PropTypes.func, 
};
